<template>
    <div>
        <b-navbar type="light" toggleable="lg" class="shadow-sm module-navbar">
            <b-navbar-toggle target="nav_dropdown_collapse"></b-navbar-toggle>
            <b-collapse id="nav_dropdown_collapse" is-nav>
                <!------- Dashboard ------->
                <b-navbar-nav v-if="showNewPatientButton">
                    <b-nav-item @click="newPatient">
                        <i class="cus-add"></i>New Patient
                    </b-nav-item>
                </b-navbar-nav>

                <!------- Profile (View) ------->
                <b-navbar-nav
                    v-if="
                        (profile.currentView === constant.PROFILE ||
                            profile.currentView ===
                                constant.DIRECT_URL_PROFILE) &&
                        profile.mode === constant.VIEW
                    "
                >
                    <b-nav-item
                        v-if="_hasAccess('patient.profile.update')"
                        @click="toggleProfileMode(constant.EDIT)"
                    >
                        <i class="cus-page-white-edit"></i>Edit Profile
                    </b-nav-item>
                    <b-nav-item @click="printCageCard">
                        <i class="cus-printer"></i>Print Cage Card
                    </b-nav-item>
                    <b-nav-item-dropdown
                        v-if="
                            _hasAccess('patient.file.email') ||
                            _hasAccess('patient.file.print')
                        "
                    >
                        <template slot="button-content">
                            <i class="cus-page-attach"></i>
                            Export
                        </template>
                        <b-dropdown-item
                            @click="exportFile('email')"
                            v-if="_hasAccess('patient.file.email')"
                        >
                            <i class="cus-email"></i>
                            Email Patient File
                        </b-dropdown-item>
                        <b-dropdown-item
                            @click="exportFile('print')"
                            v-if="_hasAccess('patient.file.print')"
                        >
                            <i class="cus-printer"></i>
                            Print Patient File
                        </b-dropdown-item>
                    </b-nav-item-dropdown>
                    <b-nav-item @click="mergePatient" v-if="isMergeable">
                        <i class="cus-arrow-refresh"></i>Merge Patient
                    </b-nav-item>
                    <b-nav-item
                        @click="confirmDelete()"
                        v-if="_hasAccess('patient.profile.delete')"
                    >
                        <i class="cus-delete"></i>Delete Patient
                    </b-nav-item>
                </b-navbar-nav>

                <!------- Profile (Edit) ------->
                <b-navbar-nav
                    v-else-if="
                        (profile.currentView === constant.PROFILE ||
                            profile.currentView ===
                                constant.DIRECT_URL_PROFILE) &&
                        profile.mode === constant.EDIT &&
                        profile.isSaving
                    "
                >
                    <b-nav-item> Saving... </b-nav-item>
                </b-navbar-nav>
                <b-navbar-nav
                    v-else-if="
                        (profile.currentView === constant.PROFILE ||
                            profile.currentView ===
                                constant.DIRECT_URL_PROFILE) &&
                        profile.mode === constant.EDIT &&
                        profile.isSaving === false
                    "
                >
                    <b-nav-item @click="saveEditProfile">
                        <i class="cus-disk"></i>Save + Done
                    </b-nav-item>
                    <b-nav-item @click="() => resetProfileState(false)">
                        <i class="cus-cancel"></i>Cancel
                    </b-nav-item>
                </b-navbar-nav>

                <!------- Letter (View) ------->
                <b-navbar-nav
                    v-else-if="
                        profile.currentView === constant.LETTER &&
                        profile.mode === constant.VIEW
                    "
                >
                    <b-nav-item
                        v-if="
                            !profile.isLock &&
                            _hasAccess('patient.letter.edit')
                        "
                        @click="toggleProfileMode(constant.EDIT)"
                    >
                        <i class="cus-page-white-edit"></i>Edit Letter
                    </b-nav-item>
                    <b-nav-item-dropdown
                        v-if="
                            _hasAccess('patient.letter.email') ||
                            _hasAccess('patient.letter.print')
                        "
                    >
                        <template slot="button-content">
                            <i class="cus-page-attach"></i>
                            Export
                        </template>
                        <b-dropdown-item
                            v-if="_hasAccess('patient.letter.email')"
                            @click="emailLetter()"
                        >
                            <i class="cus-email"></i>
                            Email Letter
                        </b-dropdown-item>
                        <b-dropdown-item
                            v-if="_hasAccess('patient.letter.print')"
                            @click="printLetter()"
                        >
                            <i class="cus-printer"></i>
                            Print Letter
                        </b-dropdown-item>
                    </b-nav-item-dropdown>
                    <b-nav-item
                        v-if="
                            !profile.isLetterEdit &&
                            !profile.isLock &&
                            letter.hasSignature &&
                            !letter.hasSigned
                        "
                        @click="signLetter()"
                    >
                        <i class="cus-page-white-key"></i>Sign Letter
                    </b-nav-item>
                    <b-nav-item
                        v-if="
                            !profile.isLetterEdit &&
                            !profile.isLock &&
                            letter.hasSignature &&
                            letter.hasSigned
                        "
                        @click="clearSigniture()"
                    >
                        <i class="cus-page-white-key"></i>Clear Signature
                    </b-nav-item>
                    <b-nav-item
                        v-if="
                            !profile.isLetterEdit &&
                            !profile.isLock &&
                            _hasAccess('patient.letter.lock')
                        "
                        @click="lockLetter()"
                    >
                        <i class="cus-lock"></i>Lock Letter
                    </b-nav-item>
                    <b-nav-item
                        v-if="
                            !profile.isLock &&
                            _hasAccess('patient.letter.delete')
                        "
                        @click="deleteLetter()"
                    >
                        <i class="cus-delete"></i>Delete Letter
                    </b-nav-item>
                </b-navbar-nav>
                <!------- Letter (Edit) ------->
                <b-navbar-nav
                    v-else-if="
                        profile.currentView === constant.LETTER &&
                        profile.mode === constant.EDIT &&
                        profile.isSaving
                    "
                >
                    <b-nav-item> Saving... </b-nav-item>
                </b-navbar-nav>
                <b-navbar-nav
                    v-else-if="
                        profile.currentView === constant.LETTER &&
                        profile.mode === constant.EDIT &&
                        profile.isSaving === false
                    "
                >
                    <b-nav-item @click="saveEditLetter">
                        <i class="cus-disk"></i>Save + Done
                    </b-nav-item>
                    <b-nav-item @click="() => resetProfileState(false)">
                        <i class="cus-cancel"></i>Cancel
                    </b-nav-item>
                </b-navbar-nav>

                <!------- Lab (View) ------->
                <b-navbar-nav
                    v-else-if="
                        labDetails &&
                        profile.currentView === constant.LAB &&
                        profile.mode === constant.VIEW
                    "
                >
                    <b-nav-item
                        v-if="
                            isOwner(
                                labDetails.data.record_resource.business_id
                            ) && _hasAccess('patient.record.update')
                        "
                        @click="toggleProfileMode(constant.EDIT)"
                        :disabled="isHasUsersChooseInvoiceInCurrentLab"
                    >
                        <i class="cus-page-white-edit"></i>Edit Lab
                    </b-nav-item>
                    <b-nav-item-dropdown>
                        <template slot="button-content">
                            <spinner v-if="isExportPrint" />
                            <i v-else class="cus-page-attach"></i>
                            Export
                        </template>
                        <template>
                            <b-dropdown-item @click="emailLab()">
                                <i class="cus-email"></i>Email Lab
                            </b-dropdown-item>
                            <dropdown-nested
                                :title="{
                                    text: 'Print Lab',
                                    icon: 'cus-printer'
                                }"
                                :list="printLabOpt"
                                @trigger-function="printLab"
                            />
                        </template>
                    </b-nav-item-dropdown>

                    <!-- Handle isLabIntegration and the URL is not empty -->
                    <b-nav-item
                        v-if="showActions && requisitionUrl != '#'"
                        @click="printRequisitionForm(requisitionUrl)"
                    >
                        <i class="cus-printer"></i>Print Requisition Form
                    </b-nav-item>

                    <!-- Handle isLabIntegration and the URL is empty or "#" -->
                    <b-nav-item
                        v-else-if="showActions"
                        @click="getRequisitionUrl(true)"
                    >
                        <i class="cus-printer"></i>
                        Print Requisition Form
                    </b-nav-item>
                    <b-nav-item
                        v-if="
                            !labDetails.data.record_resource.is_locked &&
                            isOwner(labDetails.data.record_resource.business_id)
                        "
                        @click="deleteRecord()"
                        :disabled="isHasUsersChooseInvoiceInCurrentLab"
                    >
                        <i class="cus-delete"></i>Delete Lab
                    </b-nav-item>
                    <b-nav-item
                        v-if="showFetch(labDetails)"
                        :disabled="isFetchResultDisable"
                        v-b-tooltip.hover.top
                        :title="
                            isFetchResultDisable
                                ? 'Refresh result is not available for lab item older than 6 months'
                                : ''
                        "
                        @click="fetchResult()"
                    >
                        <spinner v-if="isFetchResult" />
                        <i v-else class="cus-arrow-refresh"></i>Refresh Result
                    </b-nav-item>
                    <b-nav-item
                        v-if="showCompleteIdexxOrder()"
                        @click="completePreOrder()"
                    >
                        <i class="cus-tick"></i>Complete Order
                    </b-nav-item>
                    <b-nav-item
                        v-if="showCompleteAntechOrder()"
                        @click="completePreOrder()"
                    >
                        <i class="cus-tick"></i>Complete Order
                    </b-nav-item>
                    <b-nav-item
                        v-if="showHealthTrack()"
                        @click="openHealthTrack()"
                    >
                        <i class="cus-tick"></i>View HealthTracks
                    </b-nav-item>
                </b-navbar-nav>
                <!------- Lab (Edit) ------->
                <b-navbar-nav
                    v-else-if="
                        profile.currentView === constant.LAB &&
                        profile.mode === constant.EDIT &&
                        profile.isSaving
                    "
                >
                    <b-nav-item> Saving... </b-nav-item>
                </b-navbar-nav>
                <b-navbar-nav
                    v-else-if="
                        profile.currentView === constant.LAB &&
                        profile.mode === constant.EDIT &&
                        profile.isSaving === false
                    "
                >
                    <b-nav-item
                        @click="saveEditLab"
                        :disabled="isHasUsersChooseInvoiceInCurrentLab"
                    >
                        <i class="cus-disk"></i>Save + Done
                    </b-nav-item>
                    <b-nav-item @click="() => cancelEditLab()">
                        <i class="cus-cancel"></i>Cancel
                    </b-nav-item>
                </b-navbar-nav>
                <NavbarWebform
                    v-if="isWebform"
                    :profile="profile"
                    @changeEditMode="edit => changeEditMode(edit)"
                    @changeIsSaving="isSaving => changeIsSaving(isSaving)"
                    @deleteWebform="webform => deleteWebform(webform)"
                    @sendEmail="webform => sendEmail(webform)"
                    @sendSMS="webform => sendSMS(webform)"
                />
                <NavbarSoap
                    v-if="isSoapProfile"
                    :profile="profile"
                    @changeEditMode="edit => changeEditMode(edit)"
                    @saving-soap-details="savingCheckForm"
                    @reload-page="onSuccessLock"
                />
            </b-collapse>
            <div class="d-inline-flex">
                <b-navbar-nav class="ml-auto">
                    <vet-select-patient-filter
                        ref="select-patient-filter"
                        :filterType="filterType"
                    />
                </b-navbar-nav>
                <b-navbar-nav
                    @click="$refs['select-patient'].focus()"
                    @contextmenu="rightClickHandler"
                    class="ml-auto"
                >
                    <vet-select-patient
                        ref="select-patient"
                        :focusOnload="true"
                        placeholder="Search patients"
                        class="mr-sm-2 w-100 search nav-search responsive-form"
                        @select="gotoPatientProfile"
                    />
                </b-navbar-nav>
            </div>
        </b-navbar>

        <router-view
            ref="routerView"
            :profileMode="profile.mode"
            :isSaving="profile.isSaving"
            @edit-saved="editSaved"
            :patientDetails="patientDetails"
            :labDetails="labDetails"
            @set-patient-details="setPatientDetails"
            @set-lab-details="setLabDetails"
            @letter-status="setLetterStatus"
            @redirectToPatientProfile="redirectToPatientProfile"
            @routerview-changeissaving="changeIsSaving"
            @update-photo="updatePhoto"
            :refreshPhotoCount="refreshPhotoCount"
        ></router-view>

        <modal-patient
            :showAddNew="true"
            ref="modalPatient"
            @saved="onSavedPatient"
            enableRecordSharing
        />

        <modal-delete
            v-if="patientDetails"
            ref="modalDeletePatient"
            :patient="patientDetails"
        />

        <modal-email-certificate
            ref="modalEmailCertificate"
            :patientDetails="patientDetails"
            @onsuccess="reloadCertificate"
        />

        <modal-print-certificate
            ref="modalPrintCertificate"
            :patientDetails="patientDetails"
            @onsuccess="reloadCertificate"
        />

        <modal-export ref="modalExport" :patientDetails="patientDetails" />

        <modal-cage-card ref="modalCageCard" />

        <modal-upload-photo ref="modalUploadPhoto" />

        <modal-remove-photo
            ref="modalRemovePhoto"
            @refresh-photo="refreshPhotoCount = refreshPhotoCount + 1"
        />

        <modal-merge-patient
            ref="modalMergePatient"
            @onsuccess="redirectToPatientProfile"
        />

        <lab-email-modal
            ref="labEmailModal"
            modal-ref="labEmailModal"
            :patientDetails="patientDetails"
            :labId="labId"
        />

        <modal-delete-lab
            ref="modalDeleteLab"
            @reload="onSuccessDeleted"
            :patientId="patientId"
        />
    </div>
</template>
<script>
import vetSelectPatient from "@/module/commons/vet-select-patient.vue";
import vetSelectPatientFilter from "@/module/commons/vet-select-patient-filter";
import modalPatient from "@/module/commons/patient/modal";
import ModalEmailCertificate from "@/components/patient/modal-email-certificate";
import ModalPrintCertificate from "@/components/patient/modal-print-certificate";
import ModalExport from "@/components/patient/modal-export";
import ModalCageCard from "@/module/schedule/appointment/cage-card";
import ModalMergePatient from "@/components/patient/modal-merge";
import modalUploadPhoto from "@/components/client-photos/photo-upload-modal";
import modalRemovePhoto from "@/components/client-photos/photo-remove-modal";
import labEmailModal from "@/components/patient-lab/lab-email-modal";
import DropdownNested from "@/components/elements/dropdown/dropdown-nested";
import PatientLabService from "@/services/patient/patient-lab";
import EXTENSIONS from "@/constants/extensions";
import NavbarWebform from "@/components/webform/navbar";
import NavbarSoap from "@/components/soap/navbar";
import LAB_CONST from "@/constants/lab";
import ScheduleHelper from "@/module/schedule/helper";
import { get, isEmpty } from "lodash";

const DASHBOARD = "patient_dashboard"; // same as defined in router.js
const PROFILE = "patient_profile";
const DIRECT_URL_PROFILE = "direct-url-patient-profile";
const LETTER = "letter";
const VIEW = "VIEW";
const EDIT = "EDIT";
const LAB = "lab";

export default {
    components: {
        vetSelectPatient,
        vetSelectPatientFilter,
        modalPatient,
        ModalEmailCertificate,
        ModalPrintCertificate,
        ModalExport,
        ModalCageCard,
        ModalMergePatient,
        modalUploadPhoto,
        modalRemovePhoto,
        labEmailModal,
        DropdownNested,
        NavbarWebform,
        NavbarSoap,
        ModalDelete: () => import("@/components/patient/patient-delete"),
        ModalDeleteLab: () =>
            import("@/components/patient-lab/patient-lab-delete"),
        Spinner: () => import("@/components/elements/spinner")
    },
    mixins: [ScheduleHelper],
    data() {
        return {
            constant: {
                DASHBOARD,
                PROFILE,
                DIRECT_URL_PROFILE,
                LETTER,
                VIEW,
                EDIT,
                LAB
            },
            profile: {
                currentView: "",
                mode: VIEW,
                isSaving: false,
                isLock: false,
                isLetterEdit: false,
                edit: {} // will be used for edit details model
            },
            letter: {
                hasSignature: false,
                hasSigned: false
            },
            patientDetails: null,
            labDetails: null,
            showActions: false,
            requisitionUrl: "#",
            isExportPrint: false,
            isFetchResult: false,
            isFetchResultDisable: false,
            printLabOpt: [
                {
                    text: "Results only",
                    function_code: "RESULT_ONLY",
                    isModal: false
                },
                {
                    text: "Results and attachments",
                    function_code: "RESULT_AND_ATTACHMENT",
                    isModal: false
                }
            ],
            filterType: "all",
            refreshPhotoCount: 0
        };
    },
    watch: {
        $route(to) {
            this.toggleView(to.name);
            this.resetProfileState();
        }
    },
    computed: {
        patientId() {
            return this.patientDetails ? this.patientDetails.id : null;
        },
        labId() {
            return this.labDetails
                ? this.labDetails.data.record_resource.id
                : null;
        },
        bussinessId() {
            return this._setting.business_id;
        },
        isMergeable() {
            if (
                this._hasAccess("patient.profile.merge") &&
                this.patientDetails &&
                this.patientDetails.status === 1
            ) {
                return true;
            }
            return false;
        },
        isWebform() {
            return this.$route.name == "patient_webform";
        },
        isSoapProfile() {
            return this.$route.name == "soap";
        },
        invoiceIdLabProfile() {
            return this.profile.currentView === this.constant.LAB &&
                this.profile.mode === this.constant.EDIT
                ? this.$store.getters["billing/invoiceIdLabProfileEdit"]
                : this.$store.getters["billing/invoiceIdLabProfile"];
        },
        isHasUsersChooseInvoiceInCurrentLab() {
            return this.invoiceIdLabProfile
                ? !isEmpty(
                      this.$store.getters["billing/findUserChooseInvoice"](
                          this.invoiceIdLabProfile
                      )
                  )
                : false;
        },
        showNewPatientButton() {
            if (this._hasAccess("patient.profile.create")) {
                if (this.profile.currentView === DASHBOARD) {
                    return true;
                }

                if (this.$route.name === "lab_results") {
                    return true;
                }
            }
            return false;
        }
    },
    beforeMount() {
        this._getSetting().then(() => {
            if (!this._hasAccess("patient.access")) {
                this._redirectDefaultPage();
                this.$destroy();
            }
        });
    },
    mounted() {
        const currentRoute = this.$router.history.current.name;
        this.toggleView(currentRoute);

        this.$root.$on("update-patient-details", params => {
            this.setPatientDetails(params);
        });
    },
    sockets: {
        "v-broadcast"(params) {
            if (params.action === "document-count-refresh") {
                // trigger get count for document here
                if (this.isSoapProfile) {
                    this.$refs.routerView.reloadDocumentsCountSoap();
                } else {
                    this.$refs.routerView.$refs.tabDocuments.getTabCounts();
                }
            }
        }
    },
    beforeDestroy() {
        this.$root.$off("update-patient-details");
    },
    methods: {
        cancelEditLab() {
            this.resetProfileState(false);
            this.$store.commit("billing/setInvoiceIdLabProfileEdit", null);
        },
        showFetch(labDetails) {
            const record = labDetails.data.record_resource;

            if (!record.source) return false;

            // display refresh result button if antech order date is less than 6 months period & has lab_accession_id
            // if older than 6 months, display button in disabled state
            if (
                record.source == EXTENSIONS.CODE.CODE_ANTECH &&
                !isEmpty(record.antech_status?.lab_accession_id)
            ) {
                let orderDate = this._toDateTime(
                    record?.antechOrder?.order_date
                );

                if (orderDate && orderDate.isValid) {
                    let duration = this._now()
                        .diff(orderDate, ["months"])
                        .toObject();
                    let period = LAB_CONST.ANTECH_FETCH_RESULT_PERIOD_IN_MONTH;

                    if (duration.months > period) {
                        this.isFetchResultDisable = true;
                    }

                    return true;
                }
            }

            return (
                record.source.includes("IDEXX_DEVICE") ||
                record.source == "IDEXX"
            );
        },
        showCompleteIdexxOrder() {
            const antechOrder = get(
                this.labDetails,
                "data.record_resource.antechOrder",
                {}
            );

            if (
                antechOrder.status === "CREATED" &&
                antechOrder.source === "IDEXX"
            ) {
                return true;
            }

            return false;
        },
        showCompleteAntechOrder() {
            const antechStatus = get(
                this.labDetails,
                "data.record_resource.antech_status",
                {}
            );

            if (
                !isEmpty(antechStatus) &&
                antechStatus.antech_v6 &&
                antechStatus.order_date
            ) {
                let orderDate = this._toDateTime(
                    antechStatus?.order_date?.date
                );
                let duration = this._now().diff(orderDate, ["days"]).toObject();
                let period = LAB_CONST.ANTECH_VALIDITY_PERIOD + 1;
                let isPreOrder =
                    antechStatus.status == LAB_CONST.ANTECH_STATUS.DRAFT;

                return duration && duration.days < period && isPreOrder;
            }

            return false;
        },
        showHealthTrack() {
            const antechStatus = get(
                this.labDetails,
                "data.record_resource.antech_status",
                {}
            );

            if (
                !isEmpty(antechStatus) &&
                antechStatus.antech_v6 &&
                antechStatus?.lab_accession_id &&
                antechStatus?.antech_token
            ) {
                return antechStatus.status != LAB_CONST.ANTECH_STATUS.DRAFT;
            }

            return false;
        },
        printRequisitionForm(URL) {
            window.open(URL, "_blank");
        },
        setPatientDetails(details) {
            this.patientDetails = details;
        },
        onSuccessDeleted() {
            let soapIdEncoded =
                this.labDetails &&
                this.labDetails.data.record_resource.soap_id_encoded;

            if (soapIdEncoded) {
                let soapUrl =
                    process.env.CI_APPS + "soap/soap/view/" + soapIdEncoded;
                window.open(soapUrl, "_self");
            } else {
                this.redirectToPatientProfile(this.patientDetails.encoded_id);
            }
        },
        onSuccessLock() {
            this.$refs.routerView.reloadPage("tabMedicalNote");
        },
        redirectToPatientProfile(patientEncodedId) {
            if (patientEncodedId) {
                this.$router.replace(`/patient/profile/${patientEncodedId}`);
            } else {
                this.$router.replace("/patient/dashboard");
            }
        },
        mergePatient() {
            this.$refs.modalMergePatient.open({
                patientId: this.patientDetails.id,
                encodedId: this.patientDetails.encoded_id,
                patientName: this.patientDetails.name
            });
        },
        printCageCard() {
            let owner = this.patientDetails.primary_owner[0] || {};

            let patientId = this.patientDetails.id;

            this.$refs.modalCageCard.open({
                patient_id: patientId,
                patient: {
                    id: patientId
                },
                client_id: owner.id,
                client: {
                    id: owner.id
                }
            });
        },
        exportFile(action) {
            this.$refs.modalExport.open({ action: action });
        },
        emailCertificate() {
            this.$refs.modalEmailCertificate.open();
        },
        printCertificate() {
            this.$refs.modalPrintCertificate.open();
        },
        toggleView(routeName) {
            this.profile.currentView = routeName;
        },
        async gotoPatientProfile(record) {
            if (!record) {
                return;
            }

            try {
                const res = await this.$http.get(
                    `${process.env.BARRAMUNDI}patient/${record.id}`
                );

                const { message, resources } = res.data.response;

                if (message.code !== 200) {
                    throw new Error("Error: Unable to get patient details");
                }

                // route push
                this.pushToPatientProfile(resources.encoded_id);
            } catch (e) {
                this._message(e.message, "danger");
            }
        },
        newPatient() {
            this.checkAllowCreatePatient();
        },
        checkAllowCreatePatient() {
            this._getSubscription().then(data => {
                if (Number(data.patient_status) === 1) {
                    this.$root.$emit("display-subscription-limit", data);
                } else {
                    this.$refs.modalPatient.open();
                }
            });
        },
        onSavedPatient(patient) {
            this.pushToPatientProfile(patient.encoded_id);
        },
        pushToPatientProfile(patientEncodedId) {
            this.$router.push(`/patient/profile/${patientEncodedId}`);
        },
        toggleProfileMode(value) {
            this.profile.mode = value;
        },
        saveEditProfile() {
            this.profile.isSaving = true;
            this.$refs.routerView.saveEditProfile();
        },
        saveEditLetter() {
            this.profile.isSaving = true;
            this.$refs.routerView.saveEditLetter();
        },
        saveEditLab() {
            this.profile.isSaving = true;
            this.$refs.routerView.saveEditLab();
        },
        emailLetter() {
            this.$refs.routerView.emailLetter();
        },
        printLetter() {
            this.$refs.routerView.printLetter();
        },
        deleteLetter() {
            this.$refs.routerView.promptDelete("letter");
        },
        lockLetter() {
            this.$refs.routerView.promptLock();
        },
        signLetter() {
            this.$refs.routerView.promptSign();
        },
        clearSigniture() {
            this.$refs.routerView.clearSigniture();
        },
        setLetterStatus(result = {}) {
            if (result.isLock) {
                this.profile.isLock = true;
            } else {
                this.profile.isLock = false;
            }

            if (typeof result.isContentEdit == "boolean") {
                this.profile.isLetterEdit = result.isContentEdit;
            }
            if (typeof result.hasSignature == "boolean") {
                this.letter.hasSignature = result.hasSignature;
                if (typeof result.hasSigned == "boolean") {
                    this.letter.hasSigned = result.hasSigned;
                }
            }
        },
        editSaved(result = {}) {
            this.profile.isSaving = false;

            if (result.success) {
                this.profile.mode = VIEW;

                if (this.isSoapProfile) {
                    this.$refs.routerView.reloadSoapPage();
                }
            }
        },
        resetProfileState(clearDetails = true) {
            // Edit profile -> cancel -> should not clear details

            if (clearDetails) {
                this.patientDetails = null;
            }
            this.profile.mode = VIEW;
            this.$store.commit("patient/setDirty", false);
        },
        confirmDelete() {
            this.$refs.modalDeletePatient.open();
        },
        updatePhoto(action) {
            switch (action) {
                case "upload":
                    this.uploadPhoto();
                    break;
                case "remove":
                    this.removePhoto();
                    break;
            }
        },
        removePhoto() {
            let module = "PATIENT";
            this.$refs.modalRemovePhoto.open(module);
        },
        uploadPhoto() {
            let module = "PATIENT";
            this.$refs.modalUploadPhoto.open(module);
        },
        rightClickHandler(e) {
            if (e.which === 3) {
                this.$refs["select-patient"].focus();
            }
        },
        setLabDetails(details) {
            this.labDetails = details;
            this.getRequisitionUrl();
        },
        emailLab() {
            this.$refs.labEmailModal.open();
        },
        async printLab(type) {
            let printWithAttachment = 0;
            this.isExportPrint = true;

            if (type == "RESULT_AND_ATTACHMENT") {
                printWithAttachment = 1;
            }
            const params = {
                labId: this.labId,
                includeAttachment: printWithAttachment
            };

            await PatientLabService.printLab(params)
                .then(result => {
                    this.isExportPrint = false;

                    if (result && result.code == 200) {
                        this._message(result.message);
                        window.open(result.resource.uri);
                    } else {
                        this._message("Failed to load PDF", "danger");
                    }
                })
                .catch(err => {
                    this.isExportPrint = false;
                    this._message(err, "danger");
                });
        },
        deleteRecord() {
            let self = this;
            let date = self.labDetails.data.record_resource
                ? this._fromDateCarbon(
                      self.labDetails.data.record_resource.date
                  ).toFormat("X")
                : null;

            this.$store.dispatch("checkBillingLock", {
                date,
                onProceed: () =>
                    this.$refs.modalDeleteLab.open(
                        self.labDetails.data.record_resource
                    ),
                onError: message => this._message(message, "danger")
            });
        },
        getRequisitionUrl(printForm = false) {
            let self = this;
            if (self.labDetails) {
                let recordData = self.labDetails.data.record_resource;
                if (
                    (recordData.antech_status &&
                        recordData.antech_status.source ==
                            EXTENSIONS.CODE.CODE_ANTECH &&
                        recordData.antech_status.antech_v6) ||
                    recordData.source == EXTENSIONS.CODE.CODE_ABAXIS_FUSE
                ) {
                    return (self.showActions = false);
                }

                if (parseInt(recordData.send_to)) {
                    self.showActions = true;

                    PatientLabService.getRequisitionFormUrl({
                        lab_id: recordData.id
                    }).then(result => {
                        if (
                            result.idexx_url != "" &&
                            result.idexx_url != null
                        ) {
                            self.requisitionUrl = result.idexx_url;
                            if (printForm) {
                                // Only from button will open the new tab
                                this.printRequisitionForm(self.requisitionUrl);
                            }
                        } else if (printForm) {
                            // Only from button will show the message
                            this._message("No Requisition Form.", "warning");
                        }
                    });
                }
            }
        },
        fetchResult() {
            let self = this;
            if (self.labDetails && !self.isFetchResult) {
                self.isFetchResult = true;
                let recordResource = self.labDetails.data.record_resource;
                if (
                    recordResource.antechOrder &&
                    recordResource.antechOrder.requisition_id
                ) {
                    PatientLabService.fetchLabResult({
                        source: recordResource.antechOrder.source,
                        business_id: recordResource.antechOrder.business_id,
                        result_id: recordResource.antechOrder.requisition_id
                    }).then(result => {
                        self.isFetchResult = false;
                        if (result && result.status == 1) {
                            this._message(result.message);
                            if (result.reload == 1) {
                                this.$refs.routerView.getLabDetails();
                            }
                        } else {
                            this._message(result.message, "danger");
                        }
                    });
                }
            }
        },
        changeEditMode(isEdit) {
            this.toggleProfileMode(
                isEdit ? this.constant.EDIT : this.constant.VIEW
            );
        },
        changeIsSaving(isSaving) {
            this.profile.isSaving = isSaving;
        },
        deleteWebform(webform) {
            this.$refs.routerView.deleteWebform(webform);
        },
        sendEmail(webform) {
            this.$refs.routerView.sendEmail(webform);
        },
        sendSMS(webform) {
            this.$refs.routerView.sendSMS(webform);
        },
        reloadCertificate(obj) {
            // VET-4151 - do not reload certificate list if generated certificate is type=reminder because we do not store the certficate in patient's certificate list
            // only reload certificate list if certificate type is rabies or vaccination
            if (obj && obj.cert_type) {
                if (obj.cert_type == 0 || obj.cert_type == 2) {
                    this.$refs.routerView.reloadCertificate();
                }
            }
        },
        async savingCheckForm() {
            const isFormValid = await this.$refs.routerView.savingCheckFormValid();
            if (!isFormValid) {
                return;
            }

            this.proceedSaveEditSoap();
        },
        proceedSaveEditSoap() {
            this.$refs.routerView.savingEditSoap();
        },
        completePreOrder() {
            let self = this;

            const getLabSubmitUrl = get(
                this.labDetails,
                "data.record_resource.getLabSubmitUrl",
                ""
            );
            const lab_id = get(
                this.labDetails,
                "data.record_resource.lab_id",
                ""
            );
            const lab_extension = get(
                this.labDetails,
                "data.record_resource.lab_extension",
                ""
            );
            const antech = get(
                this.labDetails,
                "data.record_resource.antech_status",
                ""
            );

            if (getLabSubmitUrl && lab_id && lab_extension) {
                let print_lab_params = {
                    idexx_lab_id: lab_id,
                    idexx_url: [getLabSubmitUrl],
                    lab_ids: [lab_id],
                    source: lab_extension,
                    module: "appointment"
                };

                self._print_lab_order(print_lab_params).then(function (
                    lab_response
                ) {
                    if (lab_response.idexx_iframe) {
                        //load idexx iframe
                        self.$root.$emit("call_idexx_iframe", lab_response);
                    }
                });
            } else if (!isEmpty(antech)) {
                this.$root.$emit("call-antech-iframe", {
                    accession_id: [antech.accession_id],
                    antech_token: antech.antech_token
                });
            }
        },
        openHealthTrack() {
            let antech = this.labDetails.data.record_resource.antech_status;

            this.$root.$emit("call-antech-healthtracks-iframe", {
                lab_accession_id: antech.lab_accession_id,
                access_token: antech.antech_token
            });
        }
    }
};
</script>
